import React from "react";
import { cn } from "@/lib/utils";
import { useDispatch } from "react-redux";
import { setDraggingComponent } from "@/store/iframeSlice";
import { ComponentAssetType } from "@/utils/types";
import { BaseCard } from "./CommunityCard";
import { setTempoClipboardDataOnDrag } from "../Canvas/utils/canvasClipboardData";

export interface ComponentAssetCardProps {
  component: ComponentAssetType;
  selected?: boolean;
  onSelect?: () => void;
  count?: number;
}

export const ComponentAssetCard: React.FC<ComponentAssetCardProps> = ({
  component,
  selected,
  onSelect,
}) => {
  const dispatch = useDispatch();

  const handleDragStart = (e: React.DragEvent) => {
    dispatch(setDraggingComponent(component));

    setTempoClipboardDataOnDrag(e, {
      reactComponentsComId: component.id.toString(),
      insertIntoHoveredElement: true,
    });
  };

  return (
    <BaseCard
      title={component.name}
      imageUrl={component.image_url}
      selected={selected}
      onClick={onSelect}
      onDragStart={handleDragStart}
      className={cn(
        "aspect-square w-full",
        selected && "ring-1 ring-primary-500",
      )}
      isThumbnail
    />
  );
};
